import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from '~app/core/BundleProvider';
import withEnterToClick from '~app/core/withEnterToClick';
import ButtonBox from '~app/features/app/components/ButtonBox';
import DragDropFilesUpload from '~app/features/saveLoad/components/DragDropFilesUpload';

import { actions as GradingActions } from '~app/features/gradingTool';

const ClickOrEnterDiv = withEnterToClick('div');

// Step to upload student assessment files
const StudentModelsPage = ({
  modelButtons,
  fileUploader,
  handleDragDrop,
  handleFilePicker,
  fileNumber,
  setCurrentPage,
  handleGradeButtonClick,
}) => {
  const t = useT();
  const dispatch = useDispatch();
  const handleBackButtonClick = useCallback(
    e => {
      // clear student assessment models when uploading reference file
      dispatch(GradingActions.storeSubmissions([]));
      dispatch(GradingActions.setSubmissionUuids([]));
      setCurrentPage(1);
    },
    [dispatch, setCurrentPage],
  );
  return (
    <>
      <div className="Progress__button-container">
        <ClickOrEnterDiv
          key={t('back') ?? t('back')}
          className="Back__button"
          onClick={handleBackButtonClick}
          role="button"
          aria-label={t('back')}
          tabIndex="0"
        >
          {t('back')}
        </ClickOrEnterDiv>

        <ClickOrEnterDiv
          key={t('grade') ?? t('grade')}
          className={
            fileNumber === 0 ? 'Progress__button-disabled' : 'Progress__button'
          }
          onClick={fileNumber === 0 ? null : handleGradeButtonClick}
          role="button"
          aria-label={t('grade')}
          aria-disabled={fileNumber === 0 ? true : false}
          tabIndex="0"
        >
          {t('grade')}
        </ClickOrEnterDiv>
      </div>
      <DragDropFilesUpload handleDrop={handleDragDrop}>
        <div className="ButtonBox_box ButtonBox__box-upload">
          <input
            type="file"
            id="file"
            value=""
            ref={fileUploader}
            style={{ display: 'none' }}
            onChange={handleFilePicker}
            aria-label={t('file-upload')}
            aria-hidden
            multiple
          />
          <ButtonBox
            buttons={modelButtons}
            title={t('student-models')}
            description={t('student-model-description')}
            bottomText={
              fileNumber === 0
                ? undefined
                : t('student-models-uploaded', { num: fileNumber })
            }
            padded={true}
          />
        </div>
      </DragDropFilesUpload>
    </>
  );
};

export default StudentModelsPage;
